// Generated by purs version 0.15.15
import * as Data_Function from "../Data.Function/index.js";
import * as Data_String_Regex from "../Data.String.Regex/index.js";
import * as Data_String_Regex_Flags from "../Data.String.Regex.Flags/index.js";
import * as Data_String_Regex_Unsafe from "../Data.String.Regex.Unsafe/index.js";
var escapeRegex = /* #__PURE__ */ Data_String_Regex_Unsafe.unsafeRegex("[\\\"\\'/&<>]")(Data_String_Regex_Flags.global);
var escapeChar = function (v) {
    if (v === "\"") {
        return "&quot;";
    };
    if (v === "'") {
        return "&#39;";
    };
    if (v === "/") {
        return "&#x2F;";
    };
    if (v === "&") {
        return "&amp;";
    };
    if (v === "<") {
        return "&lt;";
    };
    if (v === ">") {
        return "&gt;";
    };
    return v;
};
var $$escape = /* #__PURE__ */ Data_String_Regex["replace$prime"](escapeRegex)(function ($3) {
    return Data_Function["const"](escapeChar($3));
});
export {
    $$escape as escape
};
